import SubFrasesLayer from "../../components/preguntasTalento/SubFrasesLayer";

const SubFrasesPage = () => <SubFrasesLayer />;

export default SubFrasesPage;
